'use client';

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { MultidietVariantsItem } from '@/features/multidiet-picker/components/multidiet-variants-item';
import { MultidietSetupVariantType } from '@/features/multidiet-picker/types/multidiet-setup.type';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export const MultidietPickerCarousel = ({
  className,
  layout,
  variants,
}: {
  className?: string;
  layout: 'page' | 'popup';
  variants: MultidietSetupVariantType[];
}) => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(2);
  const searchParams = useSearchParams();
  const type = searchParams.get('type');
  useEffect(() => {
    if (!api) {
      return;
    }

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  useEffect(() => {
    if (type) {
      setCurrent(variants.findIndex((variant) => variant.type === type) + 1);
    }
  }, [type]);

  const getStartIndex = () => {
    if (type) {
      return variants.findIndex((variant) => variant.type === type);
    }

    return 1;
  };

  return (
    <Carousel
      opts={{
        loop: false,
        align: 'center',
        startIndex: getStartIndex(),
      }}
      setApi={setApi}
      className={className}
    >
      <CarouselContent className='items-center pt-4 max-lg:first:ml-1 max-lg:last:mr-4'>
        {variants.map((variant, index) => {
          return (
            <CarouselItem
              key={variant.type + variant.calories}
              className='basis-2/3 pl-2 ml-2'
            >
              <MultidietVariantsItem
                size={current === index + 1 ? 'large' : 'small'}
                layout={layout}
                variant={variant}
                isBestOffer={variant.type === 'STANDARD'}
              />
            </CarouselItem>
          );
        })}
      </CarouselContent>
    </Carousel>
  );
};
